// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__O1BUt","upload":"Small_upload__1KMt3","imageWrap":"Small_imageWrap__16luk","removeBtn":"Small_removeBtn__1ccBr"};